import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ReviewCard } from '../components/Cards';
import { REVIEWS } from '../data/site';
export function Reviews() {
  return <>
      <PageHeader eyebrow="Reviews" title="Product reviews, verified by the Trust Framework" intro="Every review is scored across seven dimensions and signed off by an editor before publication." data-id="element-374" />
      <section className="max-w-editorial mx-auto px-6 py-14" data-id="element-375">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-376">
          {REVIEWS.map(r => <ReviewCard key={r.slug} review={r} data-id="element-377" />)}
        </div>
      </section>
    </>;
}